import { request } from 'assets/fetchHandler';

class UserApi {
  /**
   * 获取用户地址
   * @param 
   */
  getAddress(params) {
    return request({
      url: '/front/api/useraddress',
      params
    });
  }
  /**
   * 新增用户地址
   * @param data
   * @returns {*}
   */
  addAddress(data) {
    return request({
      url: '/front/api/useraddress',
      data,
      method: 'POST'
    });
  }
  /**
   * 修改用户地址
   * @param data
   * @returns {*}
   */
  editAddress(data) {
    return request({
      url: '/front/api/useraddress',
      data,
      method: 'PUT'
    });
  }
  /**
   * 登录成功后上报
   * @param data
   */
  actionReport(data) {
    return request({
      url: '/useraction/api/action/report',
      data,
      method: 'POST'
    });
  }
}

export default new UserApi();